// extracted by mini-css-extract-plugin
export default {"downloadPdfBtn":"DownloadChartBtn_downloadPdfBtn__6hxql","downloadPdfBtnIcon":"DownloadChartBtn_downloadPdfBtnIcon__dULcb"};